import { Coupon } from '@core/models';

export function calculateCouponDiscount(coupon: Pick<Coupon, 'items'> | null): bigint {
	return (coupon?.items ?? []).reduce(
		(discount, item) => discount + BigInt(item.valorCalculado ?? 0n),
		0n
	);
}

export function isCouponDiscountValid(discount: bigint, subtotal: bigint): boolean {
	return !(discount > subtotal && subtotal > 0n);
}

export function applyCouponDiscount(subtotal: bigint, discount: bigint): bigint {
	const effectiveDiscount = discount > subtotal ? subtotal : discount;
	return subtotal > effectiveDiscount ? subtotal - effectiveDiscount : 0n;
}
